<script>
    import List, { Item, Text, Graphic} from '@smui/list';
    export let currentPage, pageNumber, pageTitle, navigationLink;
</script>

<Item activated={currentPage===pageNumber} href={navigationLink}>
    {#if currentPage >= pageNumber}
        <Graphic class="page-number-graphic">
            <img src="images/color/icon_{pageNumber}.svg"/>
        </Graphic>
    {:else}
        <Graphic class="page-number-graphic">
            <img src="images/outline/icon_{pageNumber}.svg"/>
        </Graphic>
    {/if}
    <Text class="mdc-typography--button">{pageTitle}</Text>
</Item>
